import React from 'react';
import AssetOptions from '../../AssetOptions/AssetOptions';
import AssetSizes from '../../AssetSizes/AssetSizes';
import PaPreviewMessage from '../../Messages/PaPreviewMessage/PaPreviewMessage';

const PaPreviewForm = () => (
  <div>
    <AssetOptions />
    <AssetSizes />
    <PaPreviewMessage />
  </div>
);

export default PaPreviewForm;
